import React from 'react';
import { motion } from 'framer-motion';
import { skillCategories } from '../mock';
import {
  Cloud, Server, ArrowRightLeft, Boxes, GitMerge, Shield, Briefcase, TrendingDown
} from 'lucide-react';

const iconMap = [Cloud, Server, ArrowRightLeft, Boxes, GitMerge, Shield, Briefcase, TrendingDown];

const Skills = () => {
  return (
    <section id="skills" className="relative py-32 bg-background overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-20 pointer-events-none" />
      <div
        className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full opacity-[0.06] blur-[120px] pointer-events-none"
        style={{ background: 'radial-gradient(circle, #d97757 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <span className="mono text-xs uppercase tracking-widest text-primary mb-4 block">// 02 — Skills Matrix</span>
            <h2 className="serif text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1]">
              The toolkit,<br />
              <span className="italic text-slate-500">organized</span>.
            </h2>
          </div>
          <div className="lg:col-span-7 flex items-end">
            <p className="text-slate-400 text-lg leading-relaxed">
              Two decades distilled into eight focus areas. Each one is hands-on and current — used in production engagements, not just on a slide.
            </p>
          </div>
        </div>

        {/* Skills grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {skillCategories.map((cat, i) => {
            const Icon = iconMap[i % iconMap.length];
            return (
              <motion.div
                key={cat.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ delay: i * 0.06, duration: 0.6 }}
                className="group p-6 rounded-2xl bg-card border border-white/5 hover:border-primary/40 transition-all duration-500 hover:shadow-lg hover:shadow-primary/5 flex flex-col"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="w-10 h-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                    <Icon size={18} />
                  </div>
                  <span className="mono text-[10px] uppercase tracking-widest text-slate-600">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3 className="text-white font-semibold text-sm mb-4 leading-tight group-hover:text-primary transition-colors">
                  {cat.title}
                </h3>

                <div className="flex flex-wrap gap-1.5 mt-auto">
                  {cat.items.map((it) => (
                    <span
                      key={it}
                      className="text-[10px] mono uppercase tracking-wider px-2 py-1 rounded-md bg-white/5 text-slate-400 border border-white/5 group-hover:border-primary/15 transition-colors"
                    >
                      {it}
                    </span>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
